import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "@/store";
import { canAccessAppointments } from "@/lib/appointments-access";

/**
 * Keeps the appointments pages to people the sidebar would show them to, so a bookmarked or typed
 * URL does not open a section that is hidden everywhere else. Runs inside ProtectedRoute, which
 * waits for permissions and feature flags to load before rendering anything.
 */
export function AppointmentsRoute() {
  const { permissions } = useAppSelector((state) => state.permissions);
  const { features } = useAppSelector((state) => state.features);

  if (!canAccessAppointments(permissions, features)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
